// Texto de la guía aportado por la dueña: no modificar.
export const GUIDE_INTRO = [
  "Tu nueva pieza Lumina está diseñada para transformar tus recuerdos en arte y darles un lugar especial en tu hogar.",
  "Gracias a su sistema de fijación magnética, podrás disfrutar de una presentación elegante con efecto flotante.",
];

export const GUIDE_STEPS = [
  { title: "Elige el lugar perfecto", paras: [
    "Selecciona una pared lisa, firme, limpia y completamente seca.",
    "Evita superficies con humedad, polvo, pintura desprendida o acabados irregulares.",
  ] },
  { title: "Prepara la superficie", paras: [
    "Limpia cuidadosamente el área donde instalarás los soportes metálicos.",
    "Asegúrate de que esté completamente seca antes de continuar.",
  ] },
  { title: "Ubica los soportes", paras: [
    "Identifica los soportes metálicos que acompañan tu lámina.",
    "Sin retirar todavía la protección de la cinta adhesiva, comprueba su ubicación y alineación con los imanes instalados en la parte posterior de tu pieza Lumina.",
  ] },
  { title: "Fija los soportes a la pared", paras: [
    "Retira la película verde que protege la cinta adhesiva 3M VHB.",
    "Ubica cada soporte en la posición previamente definida y presiónalo firmemente contra la superficie.",
    "No retires ni vuelvas a colocar el soporte después de adherirlo, ya que podrías afectar la fijación.",
  ] },
  { title: "Instala tu lámina Lumina", paras: [
    "Una vez que el adhesivo haya alcanzado su tiempo de fijación recomendado, acerca cuidadosamente la lámina a los soportes.",
    "Los imanes de la parte posterior se unirán a las piezas metálicas, manteniendo tu fotografía en su lugar.",
    "Comprueba que todos los puntos de fijación estén correctamente acoplados antes de soltarla.",
  ] },
  { title: "Intercambia tus recuerdos", lead: "Un mismo espacio, infinitas historias.", paras: [
    "¿Tienes varias fotografías Lumina? ¡Puedes intercambiarlas cuando quieras!",
    "Gracias a nuestro sistema magnético, los soportes permanecen instalados en la pared, permitiéndote cambiar tus fotografías fácilmente, sin necesidad de retirar los soportes ni realizar una nueva instalación.",
    "Solo debes retirar cuidadosamente tu lámina y colocar otra que tenga un sistema de imanes compatible con la misma ubicación de los soportes.",
    "Cambia tus fotografías, renueva tus espacios y disfruta tus recuerdos favoritos cada día.",
  ] },
  { title: "Disfruta tu Lumina", paras: ["Porque tus recuerdos merecen un lugar especial."] },
];

export const GUIDE_RECOMMENDATIONS = [
  "Instala únicamente sobre superficies compatibles con la cinta adhesiva.",
  "No utilices el sistema sobre paredes húmedas, rugosas o con pintura deteriorada.",
  "Evita golpes, movimientos bruscos o tirar de la lámina hacia afuera.",
  "La cinta adhesiva es de fijación permanente y puede dañar la pintura al retirarla.",
  "Antes de instalar, verifica que los soportes y la superficie puedan sostener el peso de la lámina.",
  "Mantén los imanes y las piezas pequeñas fuera del alcance de los niños.",
];
